import { useAuthContext } from '@/context/AuthContext';
import Link from '@/storybook/components/Link/Link';
import React from 'react';
import styles from './AppLink.module.css';

export interface AppLinkProps {
  url: string;
  Icon: React.ElementType;
  name: string;
  allowedCountries?: string[];
}

const AppLink = ({ url, Icon, name, allowedCountries }: AppLinkProps) => {
  const { userInfo } = useAuthContext();
  const country = userInfo?.countries[0];
  const isAdmin = userInfo?.isAdmin;

  const isAllowed =
    isAdmin || !allowedCountries || allowedCountries.length === 0 || (!!country && allowedCountries.includes(country));

  if (!isAllowed) {
    return null;
  }

  return (
    <div className={styles.boxContainer} data-testid="app-link">
      <Link to={url} isExternal appearance="ghost">
        <Icon className={styles.icon} />
        <p className={styles.name}>{name}</p>
      </Link>
    </div>
  );
};

export default AppLink;
